module.exports = __webpack_public_path__ + "static/media/theme-colorful-card.ed49fbe0.svg";